export default __webpack_public_path__ + "static/coming-app-37d21b9b6a0e067807a2c923109e2a7b.png";